export const registration = {
  hero: {
    title: 'EachTeach 가입',
    subtitle: '우리와 함께 언어 학습 여정을 시작하세요'
  },

  // Step0: 가입 유형 분기
  step0: {
    title: '가입 방법 선택',
    subtitle: '본인에게 맞는 가입 방법을 선택하세요',
    individual: {
      title: '개인으로 가입',
      desc: '언어 교환에 참여하는 개인 사용자용'
    },
    org: {
      title: '단체로 가입',
      desc: '어학원·동아리·개인 사업자 등 단체 관리자용'
    },
    member: {
      title: '단체 멤버로 가입',
      desc: '소속 단체의 월간 코드를 가지고 계신 분용'
    },
    haveAccount: '이미 계정이 있으신가요?',
    login: '로그인'
  },

  // Google 로그인
  google: {
    button: 'Google로 계속하기',
    or: '또는',
    processing: 'Google로 이동 중...'
  },

  // 단체 가입 플로우
  org: {
    title: '단체로 가입',
    steps: {
      account: '계정',
      type: '단체 유형',
      details: '단체 정보',
      document: '신분증',
      terms: '약관 동의'
    },
    type: {
      title: '단체 유형 선택',
      subtitle: '해당하는 단체 유형을 선택하세요',
      individual_tutor: '개인 사업자 (가정교사 등)',
      individual_tutor_desc: '개인으로 어학 지도를 하는 분',
      language_school: '언어 교육기관 (어학원·학원)',
      language_school_desc: '법인으로 어학 교육을 제공하는 기관',
      community: '언어 학습 커뮤니티 (대학 동아리 등)',
      community_desc: '비영리·준영리 학습 커뮤니티'
    },
    details: {
      title: '단체 정보 입력',
      subtitle: '매칭과 청구에 사용됩니다',
      nameLabel: '단체명 *',
      namePlaceholder: '예: EachTeach Language School',
      emailLabel: '단체 이메일 *',
      emailPlaceholder: 'contact@example.com',
      websiteLabel: '웹사이트 URL',
      websitePlaceholder: 'https://example.com',
      snsLabel: 'SNS URL',
      snsPlaceholder: 'https://instagram.com/...',
      schedulingLabel: '스케줄링 방식',
      schedulingHint: '학생 주도인지 관리자 주도인지 선택할 수 있습니다 (나중에 변경 가능)',
      schedulingStudent: '학생 주도 (학생이 희망 일시를 제출)',
      schedulingManager: '관리자 주도 (관리자가 일정을 조정)'
    },
    document: {
      title: '신분증 업로드',
      subtitle: '단체의 실재 확인을 위해 신분증 또는 단체 등록증을 업로드하세요',
      label: '신분증 파일 *',
      hint: 'JPEG / PNG / PDF, 최대 10MB. 안전하게 비공개로 보관됩니다.',
      uploading: '업로드 중...',
      uploaded: '업로드 완료',
      selectFile: '파일 선택',
      changeFile: '파일 변경'
    },
    terms: {
      title: '약관 동의',
      subtitle: '신청 전에 확인해 주세요',
      agreePrefix: '',
      termsLink: '이용약관',
      and: '과 ',
      privacyLink: '개인정보 처리방침',
      agreeSuffix: '에 동의합니다'
    },
    submit: '단체 가입 신청',
    submitting: '신청 중...',
    back: '뒤로',
    next: '다음',
    success: {
      title: '단체 가입을 신청했습니다',
      body: '운영팀의 승인을 기다려 주세요. 승인 후 이메일로 알려드립니다.',
      toLogin: '로그인 페이지로'
    },
    validation: {
      typeRequired: '단체 유형을 선택해주세요',
      detailsRequired: '단체명과 이메일을 입력해주세요',
      urlInvalid: 'URL은 http(s)://로 시작해야 합니다',
      documentRequired: '신분증을 업로드해주세요',
      termsRequired: '이용약관과 개인정보 처리방침에 동의해주세요',
      fileTooLarge: '파일 크기는 10MB 이하여야 합니다',
      fileType: 'JPEG / PNG / PDF 중 하나를 업로드해주세요',
      uploadFailed: '업로드에 실패했습니다. 다시 시도해주세요'
    }
  },

  // 단체 멤버 가입 플로우
  member: {
    codeTitle: '단체 코드 입력',
    codeSubtitle: '소속 단체에서 배포한 월간 코드를 입력하세요',
    codeLabel: '단체 코드',
    codePlaceholder: '예: AB12CD34',
    verify: '코드 확인',
    checking: '확인 중...',
    invalidCode: '코드가 유효하지 않거나 만료되었습니다',
    verifiedOrg: '확인된 단체',
    planFree: 'Free',
    planPro: 'Pro',
    validUntil: '유효기간',
    back: '뒤로',
    noCode: '코드를 모르시나요?',
    contactUs: '문의하기'
  },

  // 공통: 계정 생성
  account: {
    title: '계정 생성',
    subtitle: '이메일과 비밀번호를 설정하세요',
    emailLabel: '이메일 주소',
    passwordLabel: '비밀번호',
    passwordPlaceholder: '8자 이상',
    confirmLabel: '비밀번호 확인',
    confirmPlaceholder: '다시 입력',
    next: '다음',
    processing: '처리 중...',
    passwordMismatch: '비밀번호가 일치하지 않습니다',
    passwordMin: '비밀번호는 8자 이상이어야 합니다',
    signupFailed: '계정 생성에 실패했습니다',
    emailConfirmTitle: '확인 이메일을 보냈습니다',
    emailConfirmBody: '확인 이메일을 보냈습니다. 이메일의 링크를 클릭하여 계정을 활성화하세요.',
    emailConfirmSpam: '이메일이 오지 않으면 스팸함도 확인해주세요.',
    toLogin: '로그인 페이지로'
  },


  form: {
    name: {
      label: '이름',
      placeholder: '이름을 입력하세요'
    },
    
    gender: {
      label: '성별',
      placeholder: '성별을 선택하세요',
      female: '여성',
      male: '남성',
      other: '기타'
    },
    
    nativeLanguage: {
      label: '모국어',
      placeholder: '모국어를 선택하세요'
    },
    
    secondNativeLanguage: {
      label: '제2 모국어 (선택 사항)',
      placeholder: '제2 모국어를 선택하세요 (해당되는 경우)'
    },
    
    learningLanguage: {
      label: '배우고 싶은 언어',
      placeholder: '배우고 싶은 언어를 선택하세요'
    },
    
    secondLearningLanguage: {
      label: '제2 학습 언어 (선택 사항)',
      placeholder: '제2 학습 언어를 선택하세요 (해당되는 경우)'
    },
    
    country: {
      label: '거주 국가',
      placeholder: '거주 국가를 입력하세요'
    },
    
    timezone: {
      label: '시간대',
      placeholder: '시간대를 선택하세요'
    },
    
    email: {
      label: '이메일 주소',
      placeholder: 'your.email@example.com'
    },
    
    availability: {
      label: '가능한 요일 및 시간',
      description: '각 요일에 가능한 시간대를 선택하세요'
    },
    
    languages: {
      japanese: '일본어',
      korean: '한국어',
      english: '영어',
      chinese: '중국어',
      spanish: '스페인어',
      french: '프랑스어',
      german: '독일어',
      portuguese: '포르투갈어',
      italian: '이탈리아어',
      russian: '러시아어',
      arabic: '아랍어',
      hindi: '힌디어',
      thai: '태국어',
      vietnamese: '베트남어',
      other: '기타'
    },
    
    days: {
      monday: '월요일',
      tuesday: '화요일',
      wednesday: '수요일',
      thursday: '목요일',
      friday: '금요일',
      saturday: '토요일',
      sunday: '일요일'
    },
    
    agreement: {
      terms: '이용약관',
      and: '과 ',
      privacy: '개인정보 처리방침',
      agree: '에 동의합니다'
    },
    
    validation: {
      required: '필수 항목을 입력해주세요',
      availability: '최소 하나의 요일과 시간대를 선택해주세요',
      terms: '이용약관과 개인정보 처리방침에 동의해주세요'
    },
    
    status: {
      success: '등록이 완료되었습니다! 곧 연락드리겠습니다.',
      error: '오류가 발생했습니다. 다시 시도해주세요.'
    },
    
    submit: {
      button: '등록 제출',
      submitting: '제출 중...'
    },
    
    requiredNote: '* 필수 항목'
  }
};
